import { z } from "zod";

/**
 * Ошибка API в едином конверте.
 * Сообщение — пользовательское; без формул, коэффициентов и содержимого справочников (И-1).
 */
export const apiErrorSchema = z.object({
  code: z.string().min(1),
  message: z.string().min(1),
  details: z.unknown().optional(),
});

/** Успешный конверт `{ data, error: null }`. */
export function apiSuccessSchema<T extends z.ZodTypeAny>(dataSchema: T) {
  return z.object({
    data: dataSchema,
    error: z.null(),
  });
}

/** Ошибочный конверт `{ data: null, error }`. */
export const apiFailureSchema = z.object({
  data: z.null(),
  error: apiErrorSchema,
});

/** Тип полезной ошибки API. */
export type ApiError = z.infer<typeof apiErrorSchema>;

/** Успешный ответ API. */
export type ApiSuccessEnvelope<T> = {
  data: T;
  error: null;
};

/** Ответ с ошибкой. */
export type ApiFailureEnvelope = z.infer<typeof apiFailureSchema>;

/** Любой конверт ответа. */
export type ApiEnvelope<T> = ApiSuccessEnvelope<T> | ApiFailureEnvelope;

/**
 * Собирает успешный конверт ответа.
 */
export function ok<T>(data: T): ApiSuccessEnvelope<T> {
  return { data, error: null };
}

/**
 * Собирает ошибочный конверт ответа.
 */
export function fail(error: ApiError): ApiFailureEnvelope {
  return { data: null, error };
}
